module.exports = __webpack_public_path__ + "apple-icon-180x180.png?9433d42ee78e948cac6242800f21513b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-icon-180x180.png
// module id = 131
// module chunks = 0